var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeutral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_964_1059",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z",
    fill: "#5ABA4A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_964_1059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1C5.92508 1 1 5.92508 1 12C1 18.0749 5.92508 23 12 23C18.0749 23 23 18.0749 23 12C23 5.92508 18.0749 1 12 1Z",
    fill: "#C5D0DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16099 18.163C12.7734 18.163 18.1342 12.8022 18.1342 6.18978C18.1357 4.93851 17.9409 3.69476 17.5567 2.50392C15.8718 1.51591 13.9532 0.996655 12 1.00002C5.92509 1.00002 1.00001 5.92509 1.00001 12C0.997032 13.9717 1.52673 15.9076 2.53314 17.6031C3.70641 17.9753 4.9301 18.1642 6.16099 18.163Z",
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 10,
    width: 12,
    height: 4,
    rx: 2,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutral);
export default __webpack_public_path__ + "static/media/Neutral.faf089f8c75db3e2941e5ecb97d232dd.svg";
export { ForwardRef as ReactComponent };